@if (loggedInUser?.role?.value !== "scw_whitepaper_admin") {
<mat-toolbar class="app-header">
  @if (
  isLoggedIn &&
  loggedInUser?.role?.value !== "scw_supplier_user" &&
  isSupplierRestricted &&
  displaySelectedSuplier() !== "ALL"
  ) {
  <mat-toolbar-row id="restricted-supplier-watermark" class="restricted-supplier-watermark">
    {{ displaySelectedSuplier() }} is a restricted supplier and has No
    access to SCW Application
  </mat-toolbar-row>
  }
  <!-- supplier code top panel-->
  <div class="toolbar-container">
    <mat-toolbar-row (mouseenter)="onMouseLeave()" class="header-supplaier">
      <span class="icon-cisco header-logo" style="color: #ffffff !important; font-size: 30px !important"></span>
      <div class="header-content-supplier col-9">
        <span class="header-logo-supplier" style="color: #ffffff !important">Supplier Connection Workbench</span>
        <span style="
              color: #ffffff !important;
              font-size: 12px !important;
              padding-left: 28px !important;
            ">
          <quill-view-html style="font-size: 2px !important" [content]="SCWTagLine ? SCWTagLine : ''"></quill-view-html>
        </span>
      </div>
      <div class="right-aligned-container">
        <!-- commenting chatbot -->
        <!-- <span class="material-icons"
          *ngIf="loggedInUser?.role?.value == 'scw_admin' && loggedInUser?.scChatIconEnabled == 'Y'"
          (click)="openChatbot()" matTooltip="Open Chatbot" matTooltipPosition="below"
          style="color:  lightgray !important;font-size: 36px !important;padding-right: 8px !important;padding-top: 8px !important;">
          chat
        </span> -->
        @if (
        isLoggedIn && loggedInUser?.role?.value === "scw_supplier_user"
        ) {
        <span (mouseenter)="onMouseEnterPersona(false)" style="
                color: #ffffff !important;
                font-size: 12px !important;
                text-align: right !important;
                margin-right: 16px !important;
              ">
          @if (loggedInUser?.role?.value === "scw_supplier_user") {
          {{ loggedInUser?.mcoCompany?.replace("-RFQ", "") }}
          }
        </span>
        }
        @if (isLoggedIn && isCiscoDomainUser()) {
        <img alt="" class="header-avatar" (mouseenter)="onMouseEnterPersona(true)" style="
                width: 36px;
                height: 36px;
                border-radius: 50%;
                object-fit: fill;
                object-position: center;
              " [src]="
                'https://wwwin.cisco.com/dir/photo/zoom/' +
                loggedInUser?.userId +
                '.jpg'
              " />
        } @else {
        @if (isLoggedIn) {
        <span class="material-icons user-icon" (mouseenter)="onMouseEnterPersona(true)" style="
                  color: lightgray !important;
                  font-size: 36px !important;
                  padding-right: 8px !important;
                ">
          account_circle
        </span>
        }
        }
      </div>
    </mat-toolbar-row>
    @if (isUserPersonaHovering) {
    <div class="user-persona" (mouseleave)="onMouseEnterPersona(false)">
      <div style="text-align: center">
        <strong style="font-size: 12px !important">{{
          loggedInUser?.fullName
          }}</strong>
      </div>
      <div style="text-align: center">
        <span style="font-size: 12px !important">{{
          loggedInUser?.email
          }}</span>
      </div>
      @if (loggedInUser?.role?.value === "scw_supplier_user") {
      <div style="
                text-align: center;
                border-bottom: 1px solid gray;
                padding-bottom: 4px;
              ">
        <span style="font-size: 12px !important">Component Supplier</span>
      </div>
      }
      @if (loggedInUser?.role?.value === "scw_supplier_user") {
      <div style="padding-top: 5px">
        <span style="
                  font-size: 12px !important;
                  color: #0070d2 !important;
                  cursor: pointer !important;
                  padding-bottom: 2px !important;
                " (click)="onClickMyCompanyFromPersona()">My Company</span>
      </div>
      }
      @if (loggedInUser?.role?.value !== "scw_supplier_user") {
      <div>
        @for (
        role of this.loggedInUser?.roles;
        track role;
        let i = $index
        ) {
        <span style="font-size: 12px !important">{{ role.name }}</span>
        @if (i < this.loggedInUser?.roles.length - 1) { , } } </div>
          }
          <div class="recent-links">
            <div>
              <strong style="font-size: 12px !important">Recent Visits:
              </strong>
            </div>
            @for (link of visitedLinks; track link) {
            <div style="text-align: left">
              <span style="
                    font-size: 12px !important;
                    color: #0070d2 !important;
                    cursor: pointer !important;
                  " (click)="onClickRecentVisits(link)">{{ link.linkName }}</span>
            </div>
            }
          </div>
          <div>
            <button class="button-logout" mat-raised-button (click)="logout()">
              Logout
            </button>
          </div>
      </div>
      }
    </div>
    <!-- supplier code top ends -->
    <!-- sucm starts-->
    <!-- <div class="user-persona" *ngIf="isUserPersonaHovering" (mouseleave)="onMouseEnterPersona(false)" >
<div style="text-align: center;"><strong  style="font-size: 12px !important;">{{loggedInUser?.fullName}}</strong></div>
<div style="text-align: center;"><span style="font-size: 12px !important;">{{loggedInUser?.email}}</span></div>
<div class="recent-links">
  <div>
    <strong  style="font-size: 12px !important;">Recent Visits: </strong>
  </div>
  <div *ngFor="let link of visitedLinks" style="text-align: left;">
    <span style="font-size: 12px !important;color: #0070d2 !important;cursor: pointer !important;" (click)="onClickRecentVisits(link)">{{link.linkName}}</span>
  </div>
</div>
<div>
  <button class="button-logout" mat-raised-button (click)="logout()">Logout</button>
</div>
</div> -->
    <!-- suppier menu starts -->
    @if (
    isLoggedIn &&
    (loggedInUser?.role?.value === "scw_supplier_user" ||
    loggedInUser?.role?.value === "supplier_commodity_manager_sucm" ||
    loggedInUser?.role?.value === "sourcing_commodity_manager_socm" ||
    loggedInUser?.role?.value == "commodity_directors" ||
    loggedInUser?.role?.value === "supply_chain_view_access" ||
    loggedInUser?.role?.value === "gsm_general_user_okta" ||
    loggedInUser?.role?.value === "scw_admin")
    ) {
    <mat-toolbar-row>
      <ul class="main-menu">
        @for (mainMenu of mainTabs; track mainMenu; let menuIndex = $index) {
        <span>
          @if (mainMenu.isMainTabVisible === true) {
          @if (mainMenu.mainTabUrl !== "") {
          <li class="main-menu-li" [ngClass]="
                      menuIndex === selectedMainMenuIndex
                        ? 'selected-main-menu'
                        : ''
                    " (mouseenter)="onMouseLeave()" (click)="onClickMainMenuTab(mainMenu)">
            {{ mainMenu.labelName }}
          </li>
          } @else {
          @if (mainMenu?.tabGroups && mainMenu?.tabGroups.length > 0) {
          <li class="main-menu-li" [ngClass]="
                        menuIndex === selectedMainMenuIndex
                          ? 'selected-main-menu'
                          : ''
                      " (mouseenter)="onMouseEnter(mainMenu)">
            {{ mainMenu.labelName }}
          </li>
          }
          }
          }
        </span>
        }
      </ul>
    </mat-toolbar-row>
    }
    <!-- supplier menu ends -->
</mat-toolbar>
}

<!-- Supplier Login menu panel start-->

@if (isHovering && isLoggedIn) {
<div (mouseleave)="onMouseLeave()" class="top-div" style="
      width: 99% !important;
      display: inline-flex !important;
      overflow-y: auto !important;
      margin-left: 0.5% !important
  ;
      margin-right: 0.5% !important;
      background-color: #f4f2f2;
      border-top: 1px solid #d9d9d9;
    ">
  @for (
  tabGroup of mainTabs[selectedMainMenuIndex]?.tabGroups;
  track tabGroup;
  let tabGrpIndex = $index
  ) {
  @if (
  mainTabs[selectedMainMenuIndex].mainTabName === "Favorites" &&
  favorites.length === 0
  ) {
  <div class="centered-text">No Favorites to show.</div>
  } @else {
  @if (tabGroup.isTabGroupVisible) {
  <ul class="tab-group-list-supplier">
    @if (
    tabGroup.tabGroupName &&
    tabGroup.tabGroupName !== "Questionnaire" &&
    tabGroup.tabGroupName !== "Incident Tracker" &&
    tabGroup.tabGroupName !== "Contacts" &&
    tabGroup.tabGroupName !== "PERFORMANCE SCORECARD" &&
    tabGroup.tabGroupName !== "TOOLS" &&
    tabGroup.tabGroupName !== "Trainings" &&
    tabGroup.tabGroupName !== "Messages"
    ) {
    <li class="tab-group-header-supplier" style="padding-bottom: 10px !important"
      matTooltip="{{ tabGroup.tabGroupTooltip }}" matTooltipClass="cisco-tooltip" matTooltipPosition="right">
      {{ tabGroup.tabGroupName }}
    </li>
    }
    <li>
      <ul class="sub-menu-list-supplier">
        @for (
        subTab of tabGroup?.subTabs;
        track subTab;
        let subTabIndex = $index
        ) {
        @if (subTab.isSubTabVisible) {
        <li style="padding-bottom: 12px !important" (click)="
                        onClickSubMenuTab(
                          mainTabs[selectedMainMenuIndex],
                          tabGroup,
                          subTab
                        )
                      " [ngClass]="
                        subTab.subTabName === displaySelectedTabName()
                          ? 'selected-sub-menu-item-supplier'
                          : ''
                      " matTooltip="{{ subTab.subTabTooltip }}" matTooltipClass="cisco-tooltip"
          matTooltipPosition="right">
          @if (
          mainTabs[selectedMainMenuIndex].mainTabName ===
          "Switch Company" && subTabIndex === 0
          ) {
          <span class="tab-group-header-supplier">{{
            subTab.subTabName
            }}</span>
          } @else {
          {{ subTab.subTabName }}
          }
        </li>
        }
        }
      </ul>
    </li>
  </ul>
  }
  }
  }
</div>
}
<!-- Supplier Login menu panel start-->
@if (breadcrumbs.length > 0 && isLoggedIn) {
<div id="breadcrumb" style="
      height: 24px !important;
      background-color: #ffffff !important
  ;
      margin-left: 15px !important;
    ">
  <ol class="breadcrumb" style="
        height: 24px !important;
        background-color: #ffffff !important;
        padding: 5px !important;
        padding-left: 18px !important;
      ">
    @for (
    breadcrumb of breadcrumbs;
    track breadcrumb;
    let breadcrumbIndex = $index
    ) {
    @if (breadcrumb.label !== " ") {
    <li class="breadcrumb-item" style="font-size: 14px">
      @if (
      breadcrumbIndex == 0 || breadcrumbIndex == breadcrumbs.length - 1
      ) {
      <span>
        @if (breadcrumbIndex == 0) {
        <span (click)="onClickMainMenuBreadCrum(breadcrumb)" style="
                      color: #0070d2 !important;
                      cursor: pointer !important;
                      font-weight: 400 !important;
                    ">{{ breadcrumb.label }}</span>
        } @else {
        <span (click)="onClickLastBreadCrum(breadcrumb.url)" (keypress)="onClickLastBreadCrum(breadcrumb.url)"
          (keydown)="onClickLastBreadCrum(breadcrumb.url)" (keyup)="onClickLastBreadCrum(breadcrumb.url)" style="
                      color: #0070d2 !important;
                      cursor: pointer !important;
                      font-weight: 400 !important;
                    ">{{ breadcrumb.label }}</span>
        }
        @if (
        (breadcrumbs.length === 1 ||
        (breadcrumbs.length > 1 &&
        breadcrumbIndex === breadcrumbs.length - 1)) &&
        displaySelectedSuplier() == "ALL" &&
        loggedInUser?.role?.value !== "scw_supplier_user"
        ) {
        <span (click)="toggleFavorite(breadcrumb)" (keypress)="toggleFavorite(breadcrumb)"
          style="cursor: pointer; margin-left: 5px">
          <i class="fa" [ngClass]="{
                        'fa-star': isFavorite(breadcrumb),
                        'fa-star-o': !isFavorite(breadcrumb),
                      }" [ngStyle]="{
                        color: isFavorite(breadcrumb) ? 'orange' : 'inherit',
                      }"></i>
        </span>
        }
      </span>
      } @else {
      <span>{{ breadcrumb.label }}</span>
      }
    </li>
    }
    }
    @if (displaySelectedSuplier() !== "ALL") {
    <li class="marquee-item" style="padding-left: 28px !important; margin-left: 18px !important">
      <label class="scrolling-text" style="color: red">{{
        scrollMsg
        }}</label>
    </li>
    }
  </ol>
</div>
}

<mat-sidenav-container autosize [style.height.px]="setMainContainerHeight()">
  <!-- filter panel starts -->
  @if (isLoggedIn && loggedInUser?.role?.value !== "scw_supplier_user") {
  <mat-sidenav [mode]="router.url.includes('general-user-home') ? 'side' : 'over'" [(opened)]="isFilterOpened"
    class="filter-panel" [style.height.px]="browserScreenHeight">
    <div class="row" style="height: 45px !important">
      <div class="col-12" style="text-align: end">
        <button mat-icon-button matTooltip="Reset Filter" (click)="onSelectSupplier('ALL')"
          matTooltipClass="cisco-tooltip" matTooltipPosition="right" style="width: 45px">
          <span class="icon-reset"></span>
        </button>
        <button mat-icon-button matTooltip="Info" matTooltipClass="cisco-tooltip" matTooltipPosition="right"
          (click)="onClickInfoIcon('open', 'filter-info')" style="width: 45px">
          <span class="icon-info-outline"></span>
        </button>
      </div>
    </div>
    <div class="row sidenav-fields" style="height: 65px !important">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>View By Commodity</mat-label>
          <mat-select panelClass="sidenav-select-fields" multiple (selectionChange)="onChangeCommodity()"
            [(ngModel)]="selectedCommodity" [ngModelOptions]="{ standalone: true }"
            (openedChange)="searchedText.setValue('')">
            <mat-option>
              <ngx-mat-select-search [formControl]="searchedText"
                placeholderLabel="Search Commodity"></ngx-mat-select-search>
            </mat-option>
            <mat-option class="selectAll" value="Select All">
              <mat-checkbox (change)="selectAllCommodities($event)" [(ngModel)]="isAllCommoditiesSelected"
                [ngModelOptions]="{ standalone: true }">Select All</mat-checkbox>
            </mat-option>
            @for (sucm of commodityList; track sucm) {
            <mat-option [ngClass]="{
                    'hide-unmatched-mat-option':
                      commodityList
                      | search
                        : sucm.commodityName
                        : searchedText?.value
                        : 'commodity',
                  }" [value]="sucm.commodityName">{{ sucm.commodityName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row sidenav-fields" style="height: 65px !important">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>View By SUCM</mat-label>
          <mat-select panelClass="sidenav-select-fields" multiple (selectionChange)="onChangeSucm()"
            [(ngModel)]="selectedSucm" [ngModelOptions]="{ standalone: true }"
            (openedChange)="searchedText.setValue('')">
            <mat-option>
              <ngx-mat-select-search [formControl]="searchedText"
                placeholderLabel="Search SuCM"></ngx-mat-select-search>
            </mat-option>
            <mat-option class="selectAll" value="Select All">
              <mat-checkbox (change)="selectAllSucm($event)" [(ngModel)]="isAllSucmSelected"
                [ngModelOptions]="{ standalone: true }">Select All</mat-checkbox>
            </mat-option>
            @for (sucm of sucmList; track sucm) {
            <mat-option [ngClass]="{
                    'hide-unmatched-mat-option':
                      sucmList
                      | search: sucm.sucmName : searchedText?.value : 'sucm',
                  }" [value]="sucm.sucmName">
              {{ sucm.sucmName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row sidenav-fields" style="height: 65px !important">
      <div class="col-12">
        <mat-form-field class="sortSpend" appearance="outline">
          <mat-label>Sort Spend Suppliers</mat-label>
          <mat-select (selectionChange)="onChangeSortType($event.value)" [(ngModel)]="sortSupplierType">
            <mat-option value="SortBySpend">Sort supplier by spend</mat-option>
            <mat-option value="SortAlphabetically">Sort supplier alphabetically</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row sidenav-fields">
      <div class="col-12" style="height: 45px !important">
        <mat-form-field appearance="outline">
          <mat-label>View By Supplier</mat-label>
          <input type="text" placeholder="Search Supplier..." [(ngModel)]="searchedSupplier"
            [ngModelOptions]="{ standalone: true }" matInput />
        </mat-form-field>
      </div>
      <div class="col-12" style="overflow: auto !important" [style.height.px]="setHeightOfSupplierList()">
        <mat-selection-list multiple="false">
          @for (supplier of supplierList; track supplier; let i = $index) {
          <mat-list-option [value]="changeForSpend(supplier)" class="{{ applyClassForSupplier(supplier) }}" [ngClass]="{
                  'hide-unmatched-mat-option':
                    supplierList
                    | search: changeForSpend(supplier) : searchedSupplier,
                }" (click)="onSelectSupplier(supplier)">
            {{ changeForSpend(supplier) }}&nbsp;
            @if (showRestrictedFlag(supplier)) {
            <span class="icon-blocked icon-small restricted-flag"
              matTooltip="{{ tooltipForRestrictedSupplier(supplier) }}" matTooltipClass="cisco-tooltip"></span>
            }
          </mat-list-option>
          }
        </mat-selection-list>
      </div>
    </div>
    <!-- filter panel ends -->
  </mat-sidenav>
  }

  <!-- main side content starts -->
  <div class="sidenav-content" [style.height.px]="setMainContainerHeight()" [style.overflow-y]="
      router.url.includes('supplier-home') ||
      router.url.includes('faq') ||
      router.url.includes('about-us') ||
      router.url.includes('data-refresh')
        ? 'hidden'
        : 'auto'
    " style="overflow-x: hidden !important">
    <div class="row sidenav-main-content">
      <!-- <ng-container
        *ngIf="isLoggedIn && router.url.includes('supplier-home') && (addSupplierNotes || viewSupplierNote)">
        <div class="col-12 supplier-notes-div" style="padding: 0.5% 0.5% !important;">
          <mat-card class="supplier-notes-mat-card">
            <mat-card-title-group>
              <mat-card-title>
                <div class="row">
                  <div class="col-6" style="padding-left: 0.5% !important;width: 50% !important;">
                    <label>
                      <h3 style="font-weight: 700;">Supplier Note
                      </h3>
                    </label>
                  </div>
                  <div class="col-6" *ngIf="addSupplierNotes"
                    style="padding: 0.5% 0.5% !important;width: 50% !important;text-align: end;">
                    <label style="color: red;vertical-align: -webkit-baseline-middle;font-size: 13px;font-weight: 400;">
                      Maximum 120 characters are allowed.
                    </label>
                  </div>
                  <div class="col-6" style="padding: 0.5% 0.5% !important;width: 50% !important;"
                    *ngIf="addSupplierNotes">
                    <label style="color: red;vertical-align: -webkit-baseline-middle;font-size: 13px;font-weight: 400;">
                      Note: use the "&#64;" symbol to mention a Supplier to enable the link to the Suppliers home page
                    </label>
                  </div>
                  <div class="col-6 supplier-note-action"
                    style="text-align: end;padding: 0.5% 0.5% !important;width: 50% !important;"
                    *ngIf="addSupplierNotes">

                    <mat-checkbox class="deleted-checkbox" [checked]="enableSupplierNote === 'Y'"
                      (change)="enableSupplierNote = $event.checked ? 'Y':'N'">
                    Enable Supplier Note</mat-checkbox>
                    <button mat-raised-button class="btn btn-primary" [disabled]="supplierNotes === ''"
                    (click)="saveSupplierNote('save')">Save</button>
                    <button mat-raised-button class="btn btn-dark" [disabled]="supplierNotes === ''"
                    (click)="saveSupplierNote('cancel')">Cancel</button>
                  </div>
                </div>
              </mat-card-title>
            </mat-card-title-group>
            <mat-card-content>
              <quill-editor *ngIf="addSupplierNotes" id="supplier-notes" [placeholder]="''"
                class="content-editor supplier-notes" [modules]="tools" [(ngModel)]="supplierNotes"
                [mention]="suppliers" [mentionConfig]="mentionConfig"
                (onContentChanged)="onSupplierNotesChanged($event)">
              </quill-editor>
              <quill-view-html *ngIf="viewSupplierNote" class="view-supplier-notes" [content]="supplierNotes"
                (click)="onClickSupplierNote($event)"
              [ngClass]="{'supplier-cusor-style':loggedInUser?.role?.value === 'scw_supplier_user'}"></quill-view-html>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container> -->

      <router-outlet></router-outlet>

      @if (isHelpPageOpened) {
      <div class="modal fade help-page-popup" [style.display]="isHelpPageOpened ? 'block' : 'none'"
        style="background: rgb(0 0 0 / 62%) !important">
        <div class="modal-dialog" role="document" style="max-width: 100% !important; height: 97% !important">
          <div class="modal-content" style="
                height: 95% !important;
                margin-top: 0% !important;
                background: transparent !important;
                border: none !important;
              ">
            <div class="modal-body" style="text-align: initial">
              <div class="row">
                <div class="col-12">
                  <label style="
                        color: #ffffff;
                        width: 10%;
                        position: absolute;
                        left: 78%;
                        top: 22%;
                        font-weight: 700;
                      ">To report any issue with data, create a case here</label>
                  <img src="assets/images/report_arrow.png" style="
                        width: 10% !important;
                        position: absolute;
                        top: 30px;
                        left: 88%;
                      " />
                  <label style="
                        color: #ffffff;
                        width: 10%;
                        position: absolute;
                        left: 9%;
                        top: 49%;
                        font-weight: 700;
                      ">The filter allows to view data for specific Suppliers by
                    Commodity or by SUCM</label>
                  <img src="assets/images/filter_arrow.png" style="
                        width: 10% !important;
                        position: absolute;
                        left: -1%;
                        top: 10%;
                        height: 50%;
                      " />
                  <label style="
                        color: #ffffff;
                        width: 10%;
                        position: absolute;
                        left: 13%;
                        top: 15%;
                        font-weight: 700;
                      ">Use the Menu to quickly navigate across the various
                    pages</label>
                  <img src="assets/images/menu_arrow.png" style="
                        width: 10% !important;
                        position: absolute;
                        left: 3%;
                        top: 10%;
                      " />
                </div>
              </div>
            </div>
            <div class="modal-footer" style="border: none !important">
              <div class="row" style="display: flex !important">
                <div class="col-12" style="text-align: center">
                  @if (!router.url.includes("sucm-home")) {
                  <label style="
                          color: #ffffff;
                          cursor: pointer !important;
                          font-size: 17px;
                          font-weight: 700;
                        " (click)="onClickQuickTour('close')">Close</label>
                  }
                  @if (router.url.includes("sucm-home")) {
                  <label style="
                          color: #ffffff;
                          cursor: pointer !important;
                          font-size: 17px;
                          font-weight: 700;
                        " (click)="onClickQuickTour('sucm-quick-tour')">Next</label>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  @if (openReportIssuesPopup) {
  <app-report-issues [initialTab]="reportIssuesInitialTab" (clickReportIssues)="onClickReportIssues($event)">
  </app-report-issues>
  }
  <!-- main side content ends -->
</mat-sidenav-container>

<!-- <button mat-icon-button (click)="openChatbot()" matTooltip="Open Chatbot" matTooltipPosition="below">
      <span  style="color:  lightgray !important;font-size: 30px !important;padding-right: 8px !important;" class="material-icons">chat</span>
    </button> -->

<!-- footer starts -->
<mat-toolbar class="app-footer">
  <mat-toolbar-row class="footer">
    <ul class="footer-list">
      <li>
        <a href="https://www.cisco.com/c/en/us/about/legal/terms-conditions.html" target="_blank">
          Terms & Condition
        </a>
      </li>
      <li>
        <a href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html" target="_blank">
          Privacy Statement
        </a>
      </li>
      <li>
        <a href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html#cookies" target="_blank">
          Cookie Policy
        </a>
      </li>
      <li>
        <a href="https://www.cisco.com/c/en/us/about/legal/trademarks.html" target="_blank">
          TradeMarks
        </a>
      </li>
    </ul>
    @if(isLoggedIn) {
    <div class="feedback-launcher-wrap" style="margin-left: auto !important;">
      <button mat-raised-button class="feedback-launcher" (click)="onClickFeedbackLauncher()"
        matTooltip="Provide feedback" matTooltipPosition="above"
        matTooltipClass="cisco-tooltip">
        <span class="feedback-launcher-label">Feedback</span>
      </button>
      @if (loggedInUser?.role?.value === 'scw_admin' && feedbackUnreadCount > 0) {
        <span class="feedback-unread-count-badge" aria-label="Unread feedback count">{{ feedbackUnreadCount }}</span>
      }
    </div>
    <button matMiniFab class="vote-feedback" (click)="openVotePopup = true;"
      style="margin-left: 12px !important; margin-right: 4% !important;" matTooltip="Vote for features or provide feedback"
      matTooltipPosition="above" matTooltipClass="cisco-tooltip">
      <mat-icon>feedback</mat-icon>
    </button>
    }
  </mat-toolbar-row>
</mat-toolbar>
<!-- footer ends -->

@if (infoPopup) {
<app-info-details [infoData]="readMeInfo" (clickClose)="onClickInfoIcon($event)"></app-info-details>
}

@if (isDataRefreshPopup && fadeOut) {
<div class="modal-backdrop-overlay show"></div>
}
<div class="modal fade dataRefreshPopup" [class.show]="isDataRefreshPopup"
  [style.display]="isDataRefreshPopup ? 'block' : 'none'"
  [class.data-refresh-popup-faded]="fadeOut">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="margin-top: 2% !important">
      <div class="modal-header">
        <div class="row" id="data-refresh-modal-header">
          <div class="col-11">
            <h1 class="modal-title">Data Refresh Info</h1>
          </div>
          <div class="col-1">
            <button mat-icon-button style="float: right" (click)="onClickDataIntegrationIcon('close')">
              <span class="icon-close" style="float: right"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="modal-body data-refresh-info-body" style="text-align: initial">
        <div class="row" style="margin-top: 0%; height: 100% !important">
          <div class="col-12" style="height: 100% !important">
            @if (
            enableEditInfo === true &&
            infoEditorOpen === false &&
            (loggedInUser?.role?.value === 'scw_admin' ||
            loggedInUser?.role?.value === 'supplier_commodity_manager_sucm' ||
            loggedInUser?.role?.value === 'sourcing_commodity_manager_socm')
            ) {
            <div class="data-refresh-info-edit-row">
              <button type="button" mat-button mat-raised-button class="btn btn-secondary"
                (click)="onClickInfoEdit('open')">
                Edit
              </button>
            </div>
            }
            @if (enableEditInfo === true) {
            <div class="modal-body data-refresh-info-editor-wrap" style="text-align: initial; height: 85% !important">
              <div class="col-12" style="margin-top: 0.5%">
                <div id="original-froala-editor-refresh-data-info" [froalaEditor]="froalaOptions"
                  [(froalaModel)]="dataRefreshInfoBody" [style.height.px]="setFroalaHeight()"></div>
              </div>
            </div>
            }
            @if (infoEditorOpen === true) {
            <div class="modal-footer">
              <div class="row" style="display: flex !important; justify-content: flex-end !important">
                <button mat-raised-button class="btn btn-primary" (click)="getMasterAndChildLookupIds()"
                  [disabled]="!dataRefreshInfoBody">
                  Save
                </button>
                <button mat-raised-button class="btn btn-dark" (click)="dataRefreshInfoBody = ''">
                  Reset
                </button>
                <button mat-raised-button class="btn btn-dark" (click)="onClickInfoEdit('close')">
                  Cancel
                </button>
              </div>
            </div>
            }
            @if (enableDataRefresh) {
            <ag-grid-angular #dataRefreshGrid class="ag-theme-balham" style="height: 100% !important"
              [rowData]="dataRefreshGridConfig.rowData" [columnDefs]="dataRefreshGridConfig.columnDefs"
              [defaultColDef]="dataRefreshGridDefaultColDef" [animateRows]="true" [suppressDragLeaveHidesColumns]="true"
              [columnTypes]="columnTypes" [context]="context" [components]="frameworkComponents"
              [gridOptions]="dataRefreshGridOptions">
            </ag-grid-angular>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if(openVotePopup) {
<app-vote (closeVotePopup)="openVotePopup = false"></app-vote>
}